export const SUPER_HIGH_Z_INDEX = 'z-[999999999]';